module.exports = __webpack_public_path__ + "img/search-price.ff991e3f.png";